import marketTestInboxes from "./marketTestInboxes";

const marketTestInboxService = [
    {
        matcher: 'marketTestInbox/marketTests',
        reply: config => {
            return [200, marketTestInboxes];
        }
    },
    {
        matcher: /marketTestInbox\/marketTests\/(.*)/,
        reply: config => {
            const uuid = /marketTestInbox\/marketTests\/(.*)/.exec(config.url)[1];
            const marketTest = marketTestInboxes.find(marketTest => marketTest.uuid === uuid);
            return [200, marketTest];
        }
    },
]

export default marketTestInboxService;